import React, { useState } from 'react';
import MyRequests from './MyRequests';
import NewPurchaseRequest from './NewPurchaseRequest';
import ApprovalCenter from './ApprovalCenter';
import SubmitInvoice from './SubmitInvoice';
import ViewInvoiceModal from './ViewInvoiceModal';

// This is the main router for the Procurement section.
export default function ProcurementModule({ userProfile, showModal, appId }) {
    const [procurementView, setProcurementView] = useState('myRequests');
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

    const handleSelectItem = (item) => {
        if (item.type === 'Purchase') {
            setSelectedRequest(item);
            setProcurementView('editRequest');
        } else { // It's an Invoice
            setSelectedInvoice(item);
            setIsInvoiceModalOpen(true);
        }
    };

    let currentViewComponent;
    switch(procurementView) {
        case 'newRequest':
            currentViewComponent = <NewPurchaseRequest userProfile={userProfile} showModal={showModal} appId={appId} onCancel={() => setProcurementView('myRequests')} />;
            break;
        case 'submitInvoice':
            currentViewComponent = <SubmitInvoice userProfile={userProfile} showModal={showModal} appId={appId} />;
            break;
        case 'approvalCenter':
            currentViewComponent = <ApprovalCenter userProfile={userProfile} showModal={showModal} appId={appId} />;
            break;
        case 'editRequest':
             currentViewComponent = <NewPurchaseRequest 
                                        userProfile={userProfile}
                                        key={selectedRequest.id}
                                        initialData={selectedRequest} 
                                        // --- UPDATED LOGIC ---
                                        // Allows editing if status is 'Rejected' OR 'Rejected by Finance'
                                        readOnly={selectedRequest.status !== 'Rejected' && selectedRequest.status !== 'Rejected by Finance'}
                                        showModal={showModal}
                                        onCancel={() => setProcurementView('myRequests')} 
                                        appId={appId}
                                    />;
            break;
        case 'myRequests':
        default:
            currentViewComponent = <MyRequests userProfile={userProfile} onSelectItem={handleSelectItem} showModal={showModal} appId={appId} />;
            break;
    }

    return (
        <div>
            <ProcurementNav setProcurementView={setProcurementView} activeView={procurementView} />
            <div className="mt-6">
                {currentViewComponent}
            </div>
            {isInvoiceModalOpen && 
                <ViewInvoiceModal 
                    invoice={selectedInvoice} 
                    onClose={() => setIsInvoiceModalOpen(false)} 
                    userProfile={userProfile}
                    appId={appId}
                />
            }
        </div>
    );
}

function ProcurementNav({ setProcurementView, activeView }) {
    const NavButton = ({ viewName, children }) => {
        const isActive = activeView === viewName;
        return (
            <button
                onClick={() => setProcurementView(viewName)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition ${
                    isActive ? 'bg-[#213368] text-white' : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
            >
                {children}
            </button>
        );
    };

    return (
        <div className="bg-white p-2 rounded-lg shadow-sm border flex items-center space-x-2">
            <NavButton viewName="myRequests">My Requests</NavButton>
            <NavButton viewName="newRequest">New Purchase Request</NavButton>
            <NavButton viewName="submitInvoice">Submit Invoice</NavButton>
            <NavButton viewName="approvalCenter">Approval Center</NavButton>
        </div>
    );
}